<template>
  <div class="top-message">
    <div class="info">

      <div class="info-title">
        <img width="20px" height="20px" style="display:inline-block" :src="imgUrl" alt="">
        <span>{{resourceData.name}}</span>
      </div>

      <div class="release-time">
        <span class="release-owner-name">资源来源：{{resourceData.ownerName}}</span>
        <span class="release-create-time">发布时间：{{createTime(resourceData.createTime)}}</span>
      </div>

      <div class="message">
        <div class="message-item">
          <img width="16px" height="16px" src="~@/assets/img/syncResource/daxiao.png" alt="">
          <span>大小: {{fileSize(resourceData)}}</span>
        </div>

        <div class="message-item">
          <img width="16px" height="16px" src="~@/assets/img/syncResource/liulan.png" alt="">
          <span>浏览: {{resourceData.browseNum}}</span>
        </div>

        <div class="message-item">
          <img width="16px" height="16px" src="~@/assets/img/syncResource/xiazai.png" alt="">
          <span>下载: {{resourceData.downNum}}</span>
        </div>

        <div class="message-item">
          <img width="16px" height="16px" src="~@/assets/img/resourceCenter/haoping.png" alt="">
          <span>好评: {{resourceData.likeNum}}</span>
        </div>
      </div>
    </div>

    <div class="operate">
      <div class="operate-left">
        <img @click="likeBtn" v-if="isLike==0" src="~@/assets/img/syncResource/zan.png" alt="">
        <img @click="likeBtn" v-if="isLike==1" src="~@/assets/img/syncResource/zan_active.png" alt="">
        <img @click="favoriteBtn" v-if="isFavorite==0" src="~@/assets/img/syncResource/shoucang.png" alt="">
        <img @click="favoriteBtn" v-if="isFavorite==1" src="~@/assets/img/syncResource/shoucang_active.png" alt="">
      </div>

      <div class="download">
        <el-dropdown @command='handleCommand' :hide-on-click='false'>
          <span @click="monofile" class="el-dropdown-link">
            <div style="color:#fff">下载</div>
          </span>

          <el-dropdown-menu v-if="fileIdList.length!=1" slot="dropdown">
            <el-dropdown-item :command='{value,i}' v-for="(value,i) of fileIdList" :key="resourceData.id+value">
              {{resourceData.name}}({{i+1}})
            </el-dropdown-item>
          </el-dropdown-menu>

          <!-- 单文件时 -->
          <el-dropdown-menu v-if="fileIdList.length==1"
            :style="{padding:(fileIdList.length==1?0:'10px 0'),border:(fileIdList.length==1?0:'1px solid #EBEEF5;')}"
            slot="dropdown">
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import {
  isLike,
  userLike,
  userLikeNum,
  userDislike,
  isFavorite,
  userFavorite,
  delFavorite,
  getIdResource,
  getPersignedUrl
} from "@/network/resourceRequest/api";
import utils from "@/util/index";

export default {
  name: "ResourceTopMsg",
  props: {
    //资源信息--------------------------------------------
    resourceData: {},
    //文件id数组--------------------------------------------
    fileIdList: {}
  },
  data() {
    return {
      isLike: 0,
      isFavorite: 0,
      //当前资源id--------------------------------------------
      resourceId: ""
    };
  },

  watch: {
    resourceData(newVal) {
      this.init();
    }
  },

  computed: {
    //获取图片地址--------------------------------------------
    imgUrl() {
      let type = this.resourceData.fileType;
      switch (type) {
        case "pdf":
          return require("@/assets/img/resourceCenter/pdf.png");
          break;
        case "ppt":
        case "pptx":
          return require("@/assets/img/resourceCenter/ppt.png");
          break;
        case "word":
          return require("@/assets/img/resourceCenter/word.png");
          break;
        case "excel":
          return require("@/assets/img/resourceCenter/excel.png");
          break;
        //视频--------------------------------------------
        case "mp4":
          return require("@/assets/img/resourceCenter/shipin.png");
          break;
        //音频--------------------------------------------
        case "mp3":
          return require("@/assets/img/resourceCenter/yinpin.png");
          break;
        //图片--------------------------------------------
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
        case "bmp":
          return require("@/assets/img/resourceCenter/tupian.png");
          break;
        default:
          return require("@/assets/img/resourceCenter/weizhi.png");
          break;
      }
    }
  },

  methods: {
    //初始化点赞收藏--------------------------------------------
    init() {
      this.resourceId = this.$route.query.id;

      //登录才查--------------------------------------------
      if (!this.$store.state.isLogin) return;
      //用户是否点赞
      isLike(this.resourceId).then(res => {
        if (res.data.success) {
          this.isLike = res.data.data;
        }
      });

      //用户是否收藏
      isFavorite(this.resourceId).then(res => {
        if (res.data.success) {
          this.isFavorite = res.data.data;
        }
      });
    },

    //点赞功能--------------------------------------------
    likeBtn() {
      //是否登录--------------------------------------------
      if (!this.$store.state.isLogin) return utils.tipsLogin();
      if (this.isLike == 0) {
        userLike(this.resourceId).then(res => {
          if (res.data.success) {
            this.isLike = 1;
            utils.tips("success", res.data.code);
          }
        });
      } else {
        userDislike(this.resourceId).then(res => {
          if (res.data.success) {
            this.isLike = 0;
            utils.tips("success", res.data.code);
          }
        });
      }
    },

    //收藏功能--------------------------------------------
    favoriteBtn() {
      //是否登录--------------------------------------------
      if (!this.$store.state.isLogin) return utils.tipsLogin();
      if (this.isFavorite == 0) {
        userFavorite(this.resourceId).then(res => {
          if (res.data.success) {
            this.isFavorite = 1;
            utils.tips("success", res.data.code);
          }
        });
      } else {
        delFavorite(this.resourceId).then(res => {
          if (res.data.success) {
            this.isFavorite = 0;
            utils.tips("success", res.data.code);
          }
        });
      }
    },

    //多文件下载--------------------------------------------
    handleCommand(file) {
      //是否登录--------------------------------------------
      if (!this.$store.state.isLogin) return utils.tipsLogin();
      let data = {
        id: file.value,
        fileResourceId: this.resourceId,
        filename: `${this.resourceData.name}(${file.i + 1})`
      };

      // 发送真正的网络请求
      getPersignedUrl(data).then(res => {
        if (res.data.success) {
          var link = document.createElement("a");
          //设置下载的文件名
          link.download = `${this.resourceData.name}.${
            res.data.data
              .split("?")[0]
              .split(".")
              .reverse()[0]
          }`;
          link.style.display = "none";
          //设置下载路径
          link.href = res.data.data;
          //触发点击
          document.body.appendChild(link);
          link.click();
          //移除节点
          document.body.removeChild(link);
        } else {
          utils.tips("error", res.data.code);
        }
      });
    },

    //单文件下载
    monofile() {
      //是否登录--------------------------------------------
      if (!this.$store.state.isLogin) return utils.tipsLogin();
      if (this.fileIdList.length == 1) {
        let data = {
          //文件id--------------------------------------------
          id: this.fileIdList[0],
          //资源ID--------------------------------------------
          fileResourceId: this.resourceId,
          filename: `${this.resourceData.name}`
        };

        // 发送真正的网络请求
        getPersignedUrl(data).then(res => {
          var link = document.createElement("a");
          //设置下载的文件名
          link.download = `${this.resourceData.name}.${
            res.data.data
              .split("?")[0]
              .split(".")
              .reverse()[0]
          }`;
          link.style.display = "none";
          //设置下载路径
          link.href = res.data.data;
          //触发点击
          document.body.appendChild(link);
          link.click();
          //移除节点
          document.body.removeChild(link);
        });
      }
    },
    //文件大小
    fileSize(item) {
      let KB = parseInt(item.fileSize / 1024);
      let MB = parseInt(item.fileSize / 1024 / 1024);
      let G = parseInt(item.fileSize / 1024 / 1024 / 1024);
      if (KB < 1024) {
        return KB + "KB";
      } else if (MB < 1024) {
        return MB + "MB";
      } else if (G < 1024) {
        return G + "G";
      }
    },

    //更改时间格式
    createTime(time) {
      return utils.formatTime(new Date(time).getTime());
    }
  }
};
</script>

<style lang="less" scoped>
.top-message {
  display: flex;

  margin: 20px auto 0;
  padding: 30px;
  width: 1200px;

  background-color: #fff;

  justify-content: space-between;
  align-items: center;

  .info {
    font-size: 12px;

    color: #999;

    flex: 1;

    .info-title {
      display: flex;

      height: 20px;

      font-size: 18px;
      font-weight: 400;

      color: rgba(102, 102, 102, 1);

      align-items: center;

      img {
        margin-right: 10px;
      }
    }

    .release-time {
      margin: 20px 0;

      .release-owner-name {
        margin-right: 2em;
      }
    }

    .message {
      display: flex;

      .message-item {
        display: flex;

        margin-right: 20px;

        font-weight: 400;

        color: rgba(153, 153, 153, 1);

        align-items: center;

        img {
          margin-right: 4px;
        }
      }
    }
  }

  .operate {
    display: flex;

    width: 280px;

    justify-content: flex-end;
    align-items: center;

    .operate-left {
      display: flex;

      img {
        margin-right: 20px;
        width: 50px;
        height: 50px;

        cursor: pointer;
      }
    }

    .download {
      border-radius: 2px;
      width: 120px;
      height: 48px;

      line-height: 48px;
      text-align: center;

      color: #fff;
      background-color: #24ba58;

      cursor: pointer;

      .el-dropdown {
        width: 100%;
      }
    }
  }
}

//下载下拉框样式
.el-dropdown-menu {
  /deep/.el-dropdown-menu__item:hover {
    background-color: #fff;
    color: #24ba58;
  }
}
</style>